import { render, staticRenderFns } from "./salePolicy.vue?vue&type=template&id=39b2a992&"
import script from "./salePolicy.vue?vue&type=script&lang=ts&"
export * from "./salePolicy.vue?vue&type=script&lang=ts&"
import style0 from "./salePolicy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports